var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"tracker",attrs:{"src":_vm.aseguradoraMeta.banner,"alt":"Seguros Segurify - Cotizador de Seguros de Auto","height":"550","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }